export default function ({ store, app }) {
  if (store.state.notification.topBar.alreadyLoaded) {
    store.commit('notification/removeTopBarCountry')
  } else {
    store.commit('notification/setAlreadyLoaded')
  }
}
